/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetProjectPenaltyTemplatesQueryResult } from '../../models/get-project-penalty-templates-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Params {
  Id?: string;
  ProjectId?: string;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
    rb.query('ProjectId', params.ProjectId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>;
    })
  );
}

apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet.PATH = '/api/ProjectPenaltiesTemplate/GetProjectPenaltiesTemplates';
